import React, { useEffect, useState } from 'react';
import {
  CheckboxCheckedIcon,
  CheckboxEmptyIcon,
  DownChevronIcon,
  FilterIcon,
  MinusIcon,
  PlusIcon
} from '../../modules/Icons';
import { FetchFilterOption, FetchFilterOptionValue } from '../../types/api/FiltersTypes';

const FilterSidebarComponent: React.FC<any> = (props) => {
  const { filters, selectedFilters, filterSelectionChange } = props;

  const [showSidebar, setShowSidebar] = useState<boolean>(false);
  const [showFilters, setShowFilters] = useState<Array<number>>([filters[0].option_type.id]);
  const [showScroll, setShowScroll] = useState<boolean>(false);

  const toggleFilterCategory = (filterCategory: FetchFilterOption) => {
    const id = filterCategory.option_type.id;
    const prevFilters = showFilters;
    const nextShowFiltersState = prevFilters.includes(id)
      ? prevFilters.filter((filterId: number) => filterId !== id)
      : [...prevFilters, id];
    setShowFilters(nextShowFiltersState);
  };

  const filterCategoryExpanded = (filterCategory: FetchFilterOption): boolean => {
    return showFilters.includes(filterCategory.option_type.id);
  };

  const getSelectedFiltersCountFor = (filterCategory: FetchFilterOption): number => {
    return (selectedFilters[filterCategory.option_type.id] as Array<number>)?.length
  };

  const getFilterOptionsIn = (filterCategory: FetchFilterOption): Array<FetchFilterOptionValue> => {
    return filterCategory.option_type.option_values;
  };

  const toggleFilter = (filterCategory: FetchFilterOption, filterValue: FetchFilterOptionValue) => {
    const _filterSelected = filterSelected(filterCategory, filterValue);

    const categoryKey: number = filterCategory.option_type.id;
    const values: Array<number> = selectedFilters[categoryKey] as Array<number>;

    const nextValuesState = _filterSelected ? values.filter(v => v !== filterValue.id) : [ ...(values || []), filterValue.id]
    const selectedFiltersNextState = {
      ...selectedFilters,
      [categoryKey]: nextValuesState,
    };

    filterSelectionChange(selectedFiltersNextState);
  };

  const filterSelected = (filterCategory: FetchFilterOption, filterValue: FetchFilterOptionValue): boolean => {
    return (selectedFilters[filterCategory.option_type.id] as Array<number>)?.includes(filterValue.id)
  };

  return (
    <>
      {/* Mobile */}
      <div className="block md:hidden bg-gray-900">
        <div
          onClick={() => setShowSidebar(!showSidebar)}
          className="flex items-center justify-center uppercase p-4 gap-2 font-bold eurostile cursor-pointer"
        >
          <FilterIcon /> Filter
          <DownChevronIcon className={`${showSidebar && 'rotate-180'}`} />
        </div>
      </div>

      <div className={`${showSidebar ? 'block' : 'hidden'} md:block bg-a-dark-gray`}>
        <nav
          onMouseEnter={() => setShowScroll(true)}
          className="block w-full md:w-[292px] bg-a-dark-gray text-white-60 py-6 pl-6 relative h-full"
        >
          <div className="hidden md:flex items-center text-[16px] text-white gap-2 font-medium">
            <FilterIcon /> <span className="uppercase">Filter</span>
            {Object.values(selectedFilters)?.filter((f) => (f as any).length > 0).length > 0 && (
              <a
                href='/practice-footage'
                className="block ml-auto text-gray-600 text-[14px] inter font-normal hover:text-white pr-6"
              >
                Clear all
              </a>
            )}
          </div>

          <hr className="h-px mt-4 bg-gray-200 border-0 dark:bg-gray-800 absolute left-0 right-0" />

          <div
            className={`mt-5 h-[calc(100vh+600px)] overflow-y-auto ${showScroll && 'scrollbar-custom'}`}
          >
            <ul className={`mt-5 mr-2`}>
              {filters.map((f: FetchFilterOption) => (
                <li className="pb-2 block" key={f.option_type.id}>
                  <div
                    className="my-2 flex items-center text-[16px] text-white uppercase gap-2 font-medium w-full cursor-pointer"
                    onClick={() => toggleFilterCategory(f)}
                  >
                    {f.option_type.name}
                    <div className="flex items-center justify-center align-middle ml-auto">
                      {getSelectedFiltersCountFor(f) > 0 && (
                        <div className="bg-a-blue text-white rounded-[1px] text-[12px] px-[5px] py-1">
                          {getSelectedFiltersCountFor(f)}
                        </div>
                      )}
                      <button className="p-2" data-filter={f.option_type.id}>
                        {filterCategoryExpanded(f) ? (
                          <MinusIcon data-filter={f.option_type.id} />
                        ) : (
                          <PlusIcon data-filter={f.option_type.id} />
                        )}
                      </button>
                    </div>
                  </div>
                  <ul className={filterCategoryExpanded(f) ? 'block' : 'hidden'}>
                    {getFilterOptionsIn(f).map((value: FetchFilterOptionValue) => (
                      <li
                        className="text-[15px] flex gap-2 items-center align-middle py-[7px] text-white-60 font-normal cursor-pointer hover:text-a-blue"
                        key={value.id}
                        onClick={() => toggleFilter(f, value)}
                      >
                        {filterSelected(f, value) ? (
                          <CheckboxCheckedIcon />
                        ) : (
                          <CheckboxEmptyIcon />
                        )}

                        <span
                          className={
                            filterSelected(f, value)
                              ? 'text-a-blue hover:text-a-blue'
                              : 'text-white-60 hover:text-a-blue'
                          }
                        >
                          {value.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export default FilterSidebarComponent;
